import {match} from 'ts-pattern';

import {always} from 'ramda';

import {FuelTypeEnumSchema} from '@dms/api/vehicle';

import {Nullish} from 'shared/web';

export type LevelIndicator = 'fuel' | 'battery';

/**
 * Resolves which level indicators a form shows for a vehicle with the given fuel type.
 * Electric vehicles only have a battery charge, hybrids have both, everything else
 * (including an unknown fuel type) falls back to the fuel tank alone.
 */
export const levelIndicatorsFor = (fuelType: string | Nullish): LevelIndicator[] =>
  match<string | Nullish, LevelIndicator[]>(fuelType)
    .with(FuelTypeEnumSchema.enum.FUELTYPE_ELECTRIC, always(['battery']))
    .with(FuelTypeEnumSchema.enum.FUELTYPE_HYBRID, always(['fuel', 'battery']))
    .otherwise(always(['fuel']));
